import React from "react";
import { Sun, Moon } from "lucide-react";
import { useThemeMode } from "../context/ThemeContext";

export default function ThemeToggle({ className = "", variant = "icon" }) {
  const { isDark, toggle } = useThemeMode();

  if (variant === "row") {
    return (
      <button
        type="button"
        onClick={toggle}
        data-testid="theme-toggle"
        className={`flex items-center gap-3 w-full rounded-xl px-3 py-3 text-sm text-bansal-ivory/85 active:bg-white/10 transition-colors min-h-12 ${className}`}
      >
        {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
        <span className="flex-1 text-left">{isDark ? "Light mode" : "Dark mode"}</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={isDark ? "Switch to light mode" : "Switch to dark mode"}
      data-testid="theme-toggle"
      className={`inline-grid place-items-center h-9 w-9 rounded-lg border border-border text-foreground/70 hover:text-foreground hover:bg-muted transition-colors ${className}`}
    >
      {isDark ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </button>
  );
}
